export default "__VITE_ASSET__D0QrMhak__"